import { _, helpers, ts } from '_core';

import { DraftParams, Params } from './types';
import { getBenchmarkTitle } from '../../common/utils/get-name';
import { mapName } from '../../common/utils/signal-set-utils';

export const validate = (params: DraftParams) => {
  const rhErrors = helpers.validations.validSelectedReturnHorizon(params?.return_horizon);
  if (!_.isEmpty(rhErrors)) return rhErrors;

  if (params.selected_type == 'benchmark') {
    if (!helpers.validations.validBenchmark(params.set_params?.[0].file_params?.benchmark))
      return ['Benchmark is invalid.'];
  } else {
    if (
      _.isEmpty(params.analysis_pipelined_signals) ||
      !_.some(params.analysis_pipelined_signals, (el) => el.signal_id)
    )
      return ['Signal is a required field.'];
  }

  return [];
};

export const getName = (
  params: Params,
  _context: ts.types.signalSet.SignalSetAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  if (params.selected_type == 'benchmark') {
    return getBenchmarkTitle(params.set_params[0].file_params?.benchmark, 'Relative Returns', resources.universes);
  }

  const signalsInfo = params?.analysis_pipelined_signals?.[0];

  const selectedSignal = resources.signals.find((s) => s.id == signalsInfo?.signal_id);
  const selectedPipeline = resources.pipelines.find((p) => p.id == signalsInfo?.pipeline_id);
  const selectedSpPipeline = resources.pipelines.find((p) => p.id == signalsInfo?.sp_pipeline_id);
  const suffixName = selectedSignal?.name;

  const suffixPipeline = signalsInfo.pipeline_id ? `(${selectedPipeline.name})` : '';
  const suffixSpPipeline = signalsInfo.sp_pipeline_id ? `(${selectedSpPipeline.name})` : '';

  return `Relative Returns Relative to ${suffixName} ${suffixPipeline} ${suffixSpPipeline}`;
};

export const prepareData = (
  data: ts.types.widgets.TableData,
  resources: ts.StoreState['resources'],
  signalsObj: Record<string, Partial<ts.types.signalSet.SignalMetadata>>
) => {
  if (data.length > 0) {
    const firstDate = data[0].period_start;
    const zeroData = { period_end: firstDate } as ts.types.widgets.TableData[number];

    Object.keys(data[0]).forEach((key) => {
      if (key !== 'period_start' && key !== 'period_end') {
        zeroData[key] = 0;
      }
    });

    data = [zeroData, ...data];
  }

  const newData = data.map((item) => {
    const newItem = {
      date: item.period_end,
    } as ts.types.widgets.TableData[number];

    Object.keys(item).forEach((key) => {
      if (key != 'period_start' && key != 'period_end') {
        // eslint-disable-next-line prefer-const
        let { name: mappedEntity, handle } = mapName(key, resources, signalsObj);
        if (newItem[mappedEntity] != undefined) mappedEntity = `${mappedEntity} (${handle})`;
        newItem[mappedEntity] = item[key];
      }
    });

    return newItem;
  });

  return newData;
};
